import {ChangeDetectionStrategy, Component, input, OnInit, signal} from '@angular/core';
import {VisitContext} from '../../../../visit-details/visit-context';
import {CommercialReleaseLogItem, GetCommercialReleaseHistoryLog} from '@portbase/bezoekschip-service-typescriptmodels';
import {ComparatorChain} from '../../../../common/comparator-chain';
import {sendQuery} from '../../../../common/utils';
import lodash from 'lodash';

/**
 * NEW, standalone-from-the-old-screen History tab component for the new commercial-release modal.
 * Ported verbatim (query FQN, sort/comparator logic) from the reverted `CommercialReleaseHistoryComponent`,
 * but reads the release id via a signal input (`this.id()`) instead of an `@Input() id`.
 */
@Component({
  selector: 'app-commercial-release-modal-history',
  templateUrl: './commercial-release-modal-history.component.html',
  styleUrls: ['./commercial-release-modal-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CommercialReleaseModalHistoryComponent implements OnInit {

  context = VisitContext;
  readonly items = signal<CommercialReleaseLogItem[]>([]);
  readonly id = input.required<string>();

  private logComparator = new ComparatorChain("timestamp").compare;

  ngOnInit(): void {
    sendQuery("com.portbase.bezoekschip.common.api.commercialrelease.GetCommercialReleaseHistoryLog", <GetCommercialReleaseHistoryLog>{id: this.id()},
      {showSpinner: true, caching: false})
      .subscribe((items: CommercialReleaseLogItem[]) =>
        this.items.set(lodash.assign([], items.sort(this.logComparator)).reverse()));
  }

  cast = (item: CommercialReleaseLogItem): CommercialReleaseLogItem => item;

  splitTimeAndDate = (dateAndTime: string) => dateAndTime.split(" at ");

  formatUser = (item: CommercialReleaseLogItem) => [item.user, item.fullName].filter(a => a).join(" – ");
}
